var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAdditionalRules = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "38px",
    viewBox: "0 0 30 38",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5.-Index-Builder---Create-New-Methodology---Cards---00",
    transform: "translate(-476.000000, -547.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(0.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(169.100000, 62.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-bookmark_border"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4166667,6.25 L14.5833333,6.25 C12.2916667,6.25 10.4166667,8.125 10.4166667,10.4166667 L10.4166667,43.75 L25,37.5 L39.5833333,43.75 L39.5833333,10.4166667 C39.5833333,8.125 37.7083333,6.25 35.4166667,6.25 Z M35.4166667,37.5 L25,32.9583333 L14.5833333,37.5 L14.5833333,10.4166667 L35.4166667,10.4166667 L35.4166667,37.5 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdditionalRules, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/additional_rules.0af75118.svg";
export { ForwardRef as ReactComponent };